import { Shortcut } from "@design-system/Shortcut/Shortcut";

/** Slot-boxed Enter-key hint for onboarding CTAs' `rightIcon`. */
export const EnterKeyHint = ({ className }: { className?: string }) => (
    <span data-slot-box="" className={className}>
        <Shortcut keys="enter" />
    </span>
);
